export const style = {
  payment: {
    display: `inline-block`,
    '::first-letter': {
      textTransform: `uppercase`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/transactions/main.js